var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderMobile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375.995,
    height: 250.137,
    viewBox: "0 0 375.995 250.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533",
    transform: "translate(0.995)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 375.995,
    height: 250.137,
    transform: "translate(-0.995)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linie",
    d: "M1660.37,1713.853s104.355-2.456,134.295-21.044,62.619-56.567,97.123-54.969,46.13,30.361,42,54.969-29.675,41.3-62.091,55.068-112.175,3.455-112.175,3.455-49.949-5.14-57.214,12.093-4.794,35.806,29.959,53.384,122.31-6.165,122.31-6.165,119.453-27.536,176.333-35.685",
    transform: "translate(-1658.263 -1591.889)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeDasharray: "15 10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines",
    "data-name": "Circles and lines",
    transform: "translate(371.578 -15.172) rotate(87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    transform: "translate(35 250.255)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.236,
    cy: 4.236,
    r: 4.236,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.236,
    cy: 4.236,
    r: 3.236,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(217.36 338.092)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.121,
    cy: 3.121,
    r: 3.121,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.121,
    cy: 3.121,
    r: 2.121,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(111.244 299.301)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.236,
    cy: 4.236,
    r: 4.236,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.236,
    cy: 4.236,
    r: 3.236,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    transform: "translate(119.715 265.415)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.229,
    cy: 2.229,
    r: 2.229,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.229,
    cy: 2.229,
    r: 1.229,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(42.134 104.456)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.229,
    cy: 2.229,
    r: 2.229,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.229,
    cy: 2.229,
    r: 1.229,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    transform: "translate(134.875 363.06)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.236,
    cy: 4.236,
    r: 4.236,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.236,
    cy: 4.236,
    r: 3.236,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x2: 8.026,
    y2: 8.917,
    transform: "translate(70.892 258.95)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 7.58,
    y2: 6.688,
    transform: "translate(64.255 23.305)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M-6.293,0l-5.063,12.168",
    transform: "translate(59.797 346.34)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x2: 9.809,
    y2: 2.675,
    transform: "translate(43.694 157.292)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 7.134,
    y2: 8.694,
    transform: "translate(187.264 299.301)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines-2",
    "data-name": "Circles and lines",
    transform: "matrix(0.174, 0.985, -0.985, 0.174, 590.886, 3.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62-2",
    "data-name": "Ellipse 62",
    transform: "translate(134.208 305.569)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.121,
    cy: 3.121,
    r: 3.121,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.121,
    cy: 3.121,
    r: 2.121,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58-2",
    "data-name": "Ellipse 58",
    transform: "translate(80.156 276.917)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.236,
    cy: 4.236,
    r: 4.236,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.236,
    cy: 4.236,
    r: 3.236,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60-2",
    "data-name": "Ellipse 60",
    transform: "translate(102.257 251.861)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.229,
    cy: 2.229,
    r: 2.229,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.229,
    cy: 2.229,
    r: 1.229,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59-2",
    "data-name": "Ellipse 59",
    transform: "translate(132.424 355.649)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.236,
    cy: 4.236,
    r: 4.236,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.236,
    cy: 4.236,
    r: 3.236,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82-2",
    "data-name": "Line 82",
    x2: 8.026,
    y2: 8.917,
    transform: "translate(40.936 279.159)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125-2",
    "data-name": "Path 1125",
    d: "M-6.293,0l-5.063,12.168",
    transform: "translate(55.998 343.255)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M-11.356,0l7.43,10.8",
    transform: "translate(145.954 428.837)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84-2",
    "data-name": "Line 84",
    x2: 9.809,
    y2: 2.675,
    transform: "translate(7.743 343.594)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86-2",
    "data-name": "Line 86",
    x1: 7.134,
    y2: 8.694,
    transform: "translate(164.483 276.843)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMobile);
export default __webpack_public_path__ + "static/media/headerMobile.1eeab4c13cb31abc0bb3720c5c326c8b.svg";
export { ForwardRef as ReactComponent };